import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { StopPropagationModule } from '@y42/core/stop-propagation';
import { DateTimeModule } from '@y42/date-time';
import { DaterangePickerModule } from '../daterange-picker/daterange-picker.module';
import { DateRangePickerControlComponent } from './daterange-picker-control.component';

@NgModule({
  declarations: [DateRangePickerControlComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatMenuModule,
    MatButtonModule,
    MatIconModule,
    DateTimeModule,
    DaterangePickerModule,
    StopPropagationModule,
  ],
  exports: [DateRangePickerControlComponent],
})
export class DateRangePickerControlModule {}
